export enum COMPANY_OWNERSHIP {
    OWN = 'own',
    THIRD_PARTY = 'thirdParty'
}